function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 42H3V8h6V6H1v38h8zM41 8h6v34h-6v2h8V6h-8z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 16h36v2H7zM7 24h32v2H7zM7 32h36v2H7z"
});

var SvgSnippet = function SvgSnippet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

export default SvgSnippet;